export const Section = ({ children }) => {
  return (
    <section className="mx-auto my-16 max-w-7xl px-4 sm:my-24 sm:px-6 lg:px-8">
      {children}
    </section>
  );
};
